<template>
  <div class="mng-page flex flex-col h-full">
    <div class="mng-page__header flex-shrink-0">
      <div class="mng-page__title-row">
        <h1 class="mng-page__title">Тарифы</h1>
        <span class="mng-page__count">{{ tarifList.length }}</span>
      </div>
      <div class="mng-page__filters">
        <div class="flex flex-wrap items-center gap-3">
          <el-select
            v-model="filters.state"
            @change="getTarifList"
            placeholder="Статус"
            clearable
            style="max-width: 200px"
          >
            <el-option
              v-for="opt in stateOptions"
              :key="opt.value"
              :label="opt.label"
              :value="opt.value"
            />
          </el-select>
          <el-button @click="openForm" type="primary" plain>Добавить</el-button>
        </div>
      </div>
    </div>
    <main
      class="mng-page__body flex-1 min-h-0 flex flex-col overflow-hidden"
      style="padding: 20px 26px"
    >
      <div class="flex-1 min-h-0 flex flex-col">
        <SkeletonView
          v-if="loading"
          :column="17"
          :row="12"
          size-table="large"
          style="height: 100%"
        />
        <el-table
          v-else
          border
          stripe
          class="h-full"
          height="100%"
          style="overflow-y: auto; height: 100%"
          :data="tarifList"
          @row-click="goToTariff"
        >
          <el-table-column
            prop="title"
            label="Название тарифа"
          ></el-table-column>
          <el-table-column prop="tariff" label="Тариф"></el-table-column>
          <el-table-column prop="type" label="Тип пользователя">
            <template v-slot="scope">
              {{ type[scope.row.type] }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="total > filters.limit"
          class="w-full flex items-center justify-center mt-3"
          background
          layout="pager"
          :total="total"
          :default-current-page="filters.page"
          :current-page="filters.page"
          @update:current-page="pageChange"
          :page-size="10"
        />
      </div>
    </main>
    <router-view @backWithUpdate="backWithUpdate" @getList="getTarifList" />
  </div>
</template>

<script>
import { getTarifList } from "@/api/tarif";
import SkeletonView from "@/components/skeleton/SkeletonView.vue";

export default {
  name: "tarif",
  components: {
    SkeletonView,
  },
  data() {
    return {
      tarifList: [],
      loading: false,
      total: null,
      filters: {
        page: 1,
        limit: 10,
        state: 1,
      },
      type: {
        1: "Annontator",
        2: "Verifier",
      },
    };
  },
  computed: {
    stateOptions() {
      return [
        { label: "Активные", value: 1 },
        { label: "Неактивные", value: 0 },
        { label: "Удалённые", value: -1 },
      ];
    },
  },
  async created() {
    await this.getTarifList();
  },
  methods: {
    getParams() {
      let params = {};
      if (this.filters.page > 1) {
        params.page = this.filters.page;
      }
      params.limit = this.filters.limit;
      params.state = this.filters.state;
      return params;
    },
    async getTarifList() {
      this.loading = true;
      try {
        let params = this.getParams();
        let data = await getTarifList(params);
        this.tarifList = data.data;
        this.total = data.page.total_items;
      } catch (e) {
        this.tarifList = [];
        this.total = null;
      } finally {
        this.loading = false;
      }
    },
    pageChange(page) {
      this.filters.page = page;
      this.getTarifList();
    },
    goToTariff(row) {
      console.log(row._id);
      this.$router.push({ name: "tariff-item", params: { tarif_id: row._id } });
    },
    async openForm() {
      this.$router.push({ name: "tariff-item", params: { tarif_id: "new" } });
    },
    backWithUpdate(val) {
      this.filters.state = val;
      this.getTarifList();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/manage-page.scss";
</style>
